export default __webpack_public_path__ + "static/media/Ekaterina_Zueva.ebba6f13.png";